import { request } from '@/lib/http'

export function fetchAll () {
  return request({
    url: 'active-status',
    method: 'get'
  })
}

export function fetchFiltered(queriesParams) {
  return request({
    url: `active-status`,
    method: 'get',
    params: queriesParams
  })
}

export function show (id) {
  return request({
    url: `active-status/${id}`,
    method: 'get'
  })
}

export function add (data) {
  return request({
    url: 'active-status',
    method: 'post',
    data
  })
}

export function edit (id, data) {
  return request({
    url: `active-status/${id}`,
    method: 'patch',
    data
  })
}